import { MAP_DEFAULT_VAR } from 'types';

// This may need to change after direct lodge enquiry into sentinel
export const workPlaceLocItems: any[] = [
  {
    id: 'road',
    value: 'CarriageWay',
    label: 'Road'
  },
  {
    id: 'footpath',
    value: 'Footpath',
    label: 'Footpath'
  },
  {
    id: 'nature-strip',
    value: 'Berm',
    label: 'Nature strip'
  },
  {
    id: 'private',
    value: 'Private property',
    label: 'Private'
  }
];

export const basemaps: any[] = [
  {
    id: MAP_DEFAULT_VAR.BASEMAP,
    title: 'Topography',
    fromPortal: true,
    theme: 'light'
  },
  {
    id: 'arcgis-streets',
    title: 'Streets',
    fromPortal: false,
    theme: 'light'
  },
  {
    id: 'arcgis-light-gray',
    title: 'Light grey',
    fromPortal: false,
    theme: 'light'
  },
  {
    id: 'arcgis-navigation',
    title: 'Navigation',
    fromPortal: false,
    theme: 'light'
  },
  {
    id: 'ef1d368ae3c44f398f3f444d2de4363a',
    title: 'Imagery',
    fromPortal: true,
    theme: 'dark'
  }
];

export const stateListItems: { value: string | null; label: string }[] = [
  {
    label: 'ACT',
    value: 'ACT'
  },
  {
    label: 'NSW',
    value: 'NSW'
  },
  {
    label: 'NT',
    value: 'NT'
  },
  {
    label: 'QLD',
    value: 'QLD'
  },
  {
    label: 'SA',
    value: 'SA'
  },
  {
    label: 'TAS',
    value: 'TAS'
  },
  {
    label: 'VIC',
    value: 'VIC'
  },
  {
    label: 'WA',
    value: 'WA'
  },
  {
    label: 'Other',
    value: 'OT'
  }
];

export const organisationSubscriptionExpiringDayThreshold = 3;
